export function buildStorageKey(key: string) {
  const PREFIX = 'cesg';
  return [PREFIX, key].join(':').toLowerCase();
}
